import styled from "styled-components";

export const Container = styled.div`
  max-height: 312px;
  padding: 27px 21px 17px 40px;
  overflow-y: auto;
  overflow-x: hidden;

  .titleTab {
    font-size: 14px;
    font-weight: 600;
    line-height: 19px;
    color: ${({ theme }) => theme.colors.surface.onSurface};
  }

  .disciplinasList {
    padding-top: 10px;
  }
`;

export const Toolbar = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  padding-top: 12px;

  .searchBox {
    flex: 1;
    height: 36px;
    display: flex;
    align-items: center;
    border-radius: 6px;
    border: 1px solid ${({ theme }) => theme.colors.surface.surfaceOutline};
  }

  .toolbarBtn {
    display: flex;
    align-items: center;
    height: 36px !important;
    flex-shrink: 0;

    .actionIcon {
      color: ${({ theme }) => theme.colors.secondary.onSecondary} !important;
    }

    .textBtn {
      font-size: 12px;
      font-weight: 600;
      line-height: 16px;
      color: ${({ theme }) => theme.colors.secondary.onSecondary};
      margin-left: 6px;
    }
  }
`;
